// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"667":"73894f05","977":"88af8472"}[chunkId] + ".chunk.js";
};